import {
  Box,
  Button,
  Grid,
  Typography,
  Backdrop,
  CircularProgress,
  DialogTitle,
  DialogContent,
  Dialog,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNotification } from "../../../../hooks/useNotification";
import useStyles from "../../../../themes/style.js";
import CloseIcon from "@material-ui/icons/Close";
import { IoExit } from "react-icons/io5";


const SeparationDetails = ({ userDetails, onUpdate }) => {
  const classes = useStyles();
  const token = localStorage.getItem("token");
  const [loader, setLoader] = useState(false);
  const [employeeData, setEmployeeData] = useState({});
  const [confimationOpen, setConfimationOpen] = useState(false);

  const handleConfirmationModalOpen = () => {
    setConfimationOpen(true);
  };

  const handleConfirmationModalClose = () => {
    setConfimationOpen(false);
  };

  const handleNotificationCall = useNotification();


  useEffect(() => {
    if (userDetails) {
      const employee = userDetails?.employee
        ? userDetails?.employee
        : userDetails.recruiter;
      
        setEmployeeData(employee);
      }
    }, []);

  async function handleEmployeeSeparation() {
    setLoader(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER}employee/triggerSeperation`,
        {
          userId: userDetails?.id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );
      setLoader(false);
      if (response.data.status) {
        handleNotificationCall("success", response.data.message);
        onUpdate();
        handleConfirmationModalClose();
      } else {
        handleNotificationCall("error", response.data.message);
      }
    } catch (error) {
      setLoader(false);
      console.log("Error Fetch Profile Data", error);
    }
  }

  return (
    <div>
      <Box>
        <div className="emp-profile-details-table-card">
          <h3 className="gradienttext">Separation</h3>

          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Box mb={2}>
                {!employeeData?.isSentReleave ? (
                  <Box
                    display="flex"
                    flexDirection="column"
                    gridGap={8}
                    width="max-content"
                  >
                    <Button
                      variant="contained"
                      size="small"
                      color="secondary"
                      endIcon={<IoExit />}
                      className={classes.addUser}
                      style={{ paddingTop: "10px" }}
                      onClick={handleConfirmationModalOpen}
                    >
                      Initiate Employee Separation
                    </Button>
                    <Typography
                      component="p"
                      style={{
                        fontSize: "14px",
                        color: "#FF2929",
                        fontWeight: 700,
                      }}
                    >
                      (Initiate Employee Separation Menu in Employee Login)
                    </Typography>
                  </Box>
                ) : (
                  <Typography
                    component="p"
                    style={{
                      fontSize: "18px",
                      color: "#5CB338",
                      fontWeight: 700,
                    }}
                  >
                    HR & Hiring Manager Response
                  </Typography>
                )}
              </Box>
            </Grid>
          </Grid>

          <Dialog
            onClose={handleConfirmationModalClose}
            aria-labelledby="dialog-title"
            open={confimationOpen}
            width="md"
            PaperProps={{
              style: {
                width: "100%",
              },
            }}
          >
            <DialogTitle className={classes.digTitle}>
              <div className={classes.center}>
                <Typography
                  variant="subtitle2"
                  className={classes.digColor + " " + classes.digCenter}
                >
                  Confirmation
                </Typography>

                <div className={classes.drawerClose}>
                  <CloseIcon
                    className={classes.digClose}
                    onClick={handleConfirmationModalClose}
                    size="14px"
                  />
                </div>
              </div>
            </DialogTitle>

            <DialogContent className={classes.chatListBackGround}>
              <Typography variant="subtitle2">
                Do you really wish to separate this employee from the
                organization?
              </Typography>
              <div className={classes.sendWhatsapp}>
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  onClick={handleEmployeeSeparation}
                >
                  Yes
                </Button>

                <Button
                  variant="contained"
                  size="small"
                  color="secondary"
                  onClick={handleConfirmationModalClose}
                >
                  No
                </Button>
              </div>
            </DialogContent>
          </Dialog>
        </div>
        <Backdrop className={classes.backdrop} open={loader}>
          <CircularProgress color="inherit" />
        </Backdrop>
      </Box>
    </div>
  );
};

export default SeparationDetails;
